/* Pakuotės ir surinkimo mokesčiai (2026-10-08) — krepšelyje laiko tiek mokesčio eilučių, kiek reikia:
   pakuotės — kai krepšelyje yra siunčiamų prekių; surinkimo — kai jų suma (be mokesčių, po nuolaidų)
   mažesnė už ribą. Konfigūracija ir ta pati taisyklė Liquid'e — snippets/ls-fees.liquid.
   Mokesčio eilutės atpažįstamos pagal produkto tipą „Mokestis".
   Keičiama per /cart/update.js (ne add.js) — Meta pikselis mokesčio neregistruoja kaip „AddToCart".
   Nepavykus — checkout mygtukas atrakinamas (pirkti trukdyti negalima), klaida konsolėje. */
(function () {
  'use strict';

  var el = document.getElementById('ls-fees-config');
  if (!el || window.__lsFees) return;
  window.__lsFees = true;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }

  var FEE_TYPE = 'Mokestis';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var onCartPage = !!document.querySelector('[data-section-type="cart"]');
  var busy = false, again = false, dirty = false, stopped = false, timer = null;

  function isFee(it) { return it.product_type === FEE_TYPE; }

  function wanted(cart) {
    var ship = 0, sub = 0, w = {};
    cart.items.forEach(function (it) {
      if (isFee(it) || !it.requires_shipping) return;
      ship += 1;
      sub += it.final_line_price;
    });
    if (cfg.on && cfg.pack) w[cfg.pack] = ship ? 1 : 0;
    if (cfg.on && cfg.hand) w[cfg.hand] = ship && cfg.min > 0 && sub < cfg.min ? 1 : 0;
    return w;
  }

  // {variant_id: kiekis} pakeitimai arba null, jei krepšelis jau teisingas
  function updates(cart) {
    var have = {}, w = wanted(cart), upd = {}, n = 0;
    cart.items.forEach(function (it) {
      if (isFee(it)) have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity;
    });
    Object.keys(have).forEach(function (vid) { if (!(vid in w)) { upd[vid] = 0; n++; } });
    Object.keys(w).forEach(function (vid) { if ((have[vid] || 0) !== w[vid]) { upd[vid] = w[vid]; n++; } });
    return n ? upd : null;
  }

  // Liquid užrakina mygtuką, kai mokesčių eilutės dar neteisingos — atrakinam (pasikeitus arba nepavykus)
  function release() {
    document.querySelectorAll('[data-ls-fees-pending]').forEach(function (b) {
      b.removeAttribute('disabled');
      b.removeAttribute('data-ls-fees-pending');
    });
  }

  // apsauga nuo perkrovimų ciklo: ne daugiau 2 per 30 s
  function mayReload() {
    try {
      var now = Date.now();
      var log = JSON.parse(sessionStorage.getItem('lsFeesReloads') || '[]').filter(function (t) { return now - t < 30000; });
      if (log.length >= 2) return false;
      log.push(now);
      sessionStorage.setItem('lsFeesReloads', JSON.stringify(log));
    } catch (e) { /* be sessionStorage — leidžiam */ }
    return true;
  }

  function done(changed) {
    if (!changed) { release(); return; }
    if (onCartPage && mayReload()) { location.reload(); return; }
    release();
    document.dispatchEvent(new CustomEvent('cart:sync'));
  }

  function sync() {
    if (stopped) return;
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var upd = updates(cart);
        if (!upd) return false;
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: upd })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart/update.js ' + r.status); return r.json(); })
          .then(function (after) {
            if (updates(after)) throw new Error('mokesčių eilutės nepasikeitė');
            return true;
          });
      })
      .then(function (changed) {
        busy = false;
        if (changed) dirty = true;
        if (again) { again = false; sync(); return; }
        var d = dirty;
        dirty = false;
        if (added && !onCartPage) { added = false; toast(); }
        done(d);
      })
      .catch(function (e) {
        busy = false;
        stopped = true;
        release();
        if (window.console) console.warn('[ls-fees]', e && e.message);
      });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(sync, ms);
  }

  // Pranešimas po KIEKVIENO prekės pridėjimo, kol taikomas surinkimo mokestis: kiek trūksta iki ribos (Martynas
  // 2026-10-10). Krepšelio puslapyje nerodomas (ten „?“ prie mokesčio). Tekstas — cfg.toast (Liquid vertimas).
  var added = false;
  function money(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function toast() {
    if (!cfg.toast || !cfg.hand || !(cfg.min > 0)) return;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sub = 0, hand = false;
        cart.items.forEach(function (it) {
          if (it.variant_id === cfg.hand) hand = true;
          if (!isFee(it) && it.requires_shipping) sub += it.final_line_price;
        });
        if (!hand || sub >= cfg.min) return;
        if (!document.getElementById('ls-fees-toast-css')) {
          var css = document.createElement('style');
          css.id = 'ls-fees-toast-css';
          css.textContent = '.ls-fees-toast{position:fixed;top:16px;left:50%;z-index:2147483000;width:440px;max-width:calc(100vw - 24px);'
            + 'padding:14px 44px 14px 16px;border-radius:8px;background:#1c1b1b;color:#fff;font-size:14px;line-height:1.45;'
            + 'box-shadow:0 8px 24px rgba(0,0,0,.25);opacity:0;transform:translate(-50%,-8px);transition:opacity .2s,transform .2s}'
            + '.ls-fees-toast.is-on{opacity:1;transform:translate(-50%,0)}'
            + '.ls-fees-toast button{position:absolute;top:8px;right:8px;width:28px;height:28px;padding:0;border:0;background:none;color:#fff;font-size:20px;line-height:1;cursor:pointer}';
          document.head.appendChild(css);
        }
        var old = document.querySelector('.ls-fees-toast');
        if (old) old.remove();
        var el = document.createElement('div');
        el.className = 'ls-fees-toast';
        el.setAttribute('role', 'status');
        el.textContent = cfg.toast.replace('[[missing]]', money(cfg.min - sub, cart.currency));
        var x = document.createElement('button');
        x.type = 'button';
        x.setAttribute('aria-label', '×');
        x.textContent = '×';
        el.appendChild(x);
        document.body.appendChild(el);
        var hide = function () { el.classList.remove('is-on'); setTimeout(function () { el.remove(); }, 250); };
        x.addEventListener('click', hide);
        requestAnimationFrame(function () { el.classList.add('is-on'); });
        setTimeout(hide, 8000);
      })
      .catch(function () {});
  }

  // bet koks krepšelio pakeitimas (tema, dovanos, kartu perkamos prekės) → perskaičiuoti
  // Kasoje eilutės rodomos krepšelio tvarka — naujausia viršuje. Kad mokesčiai būtų PO prekėmis, jie turi
  // atsirasti krepšelyje ANKSČIAU už prekę: prieš pirmą prekę į TUŠČIĄ krepšelį juos įdedam iš anksto
  // (surinkimo — irgi; nereikalingą sync() po pridėjimo nuima). Nepavykus — prekė dedama kaip įprasta.
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  function preFees() {
    if (!cfg.on || !cfg.pack || stopped) return Promise.resolve();
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items.length) return;   // tik pirmai prekei: kitaip mokesčiai atsidurtų tarp senų ir naujų prekių
        var upd = {};
        upd[cfg.pack] = 1;
        if (cfg.hand && cfg.min > 0) upd[cfg.hand] = 1;
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: upd })
        });
      })
      .catch(function () {});
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = ADD_RE.test(url)
      ? preFees().then(function () { return nativeFetch(input, init); })
      : nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(function (r) { if (r && r.ok && ADD_RE.test(url)) added = true; schedule(350); }, function () {});
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(0); });
  else schedule(0);
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(0); });
  // jei kas nors užstrigo — po 8 s mygtukas atrakinamas bet kokiu atveju
  setTimeout(release, 8000);
})();
